import React from 'react';

import { Helmet } from 'react-helmet';

export const ABTestingIntegration = () => {
  return (
    <Helmet>
      <script id="abjs">
        {`
      !function(c,h,i,m,p)
      {
        ((m = c.createElement(h)),
        (p = c.getElementsByTagName(h)[0]),
        (m.async = 1),
        (m.src = i),
        p.parentNode.insertBefore(m, p))
      }
      (document,"script","https://www.googleoptimize.com/optimize.js?id=OPT-WGZLQW9");
      `}
      </script>
    </Helmet>
  );
};

export default ABTestingIntegration;
